var _regeneratorRuntime = require("/var/www/app-veckoappen-admin-front/packages/AdminFront/node_modules/inferno-scripts/node_modules/babel-preset-inferno-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/var/www/app-veckoappen-admin-front/packages/AdminFront/node_modules/inferno-scripts/node_modules/babel-preset-inferno-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var Interface = require('component-registry').createInterfaceClass('influence-interfaces');

var IObject = new Interface({
  // Base Object
  name: 'IProtonObject'
});
IObject.prototype._type = "string";
module.exports.IObject = IObject;
var IObjectPrototypeFactory = new Interface({
  // Base Object
  name: 'IObjectPrototypeFactory'
}); // getPrototype: "function returns an object prototype",

IObjectPrototypeFactory.prototype.getPrototype = function () {}; // getObject: "function (data) returns a new object"


IObjectPrototypeFactory.prototype.getObject = function (data) {};

module.exports.IObjectPrototypeFactory = IObjectPrototypeFactory;
var IRelationResolverFactory = new Interface({
  // Use this to register a relation resolver new Utility({
  name: 'IRelationResolverFactory'
}); // "function returns a relation resolver"

IRelationResolverFactory.prototype.getResolver = function () {};

module.exports.IRelationResolverFactory = IRelationResolverFactory;
var IDeserialize = new Interface({
  // new Utility({ to convert JSON data to a proper data structure
  // with proper ProtonCMS objects where applicable
  name: 'IDeserialize'
});

IDeserialize.prototype.deserialize = function () {};

module.exports.IDeserialize = IDeserialize;
var IObjectPersist = new Interface({
  // Manipulate data (in place) so it can be stored
  // This is an adapter to benefit from overriding, but actions
  // are performed on passed data so we don't by mistake get default values
  // when instantiating objects if those properties aren't passed to the API for persisting.
  // This could happen for subforms or forms with limited set of shown fields.
  name: 'IObjectPersist'
});

IObjectPersist.prototype.prepareForDelete = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var dbUtil, ctx;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            dbUtil = _ref.dbUtil, ctx = _ref.ctx;

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref2.apply(this, arguments);
  };
}();

IObjectPersist.prototype.prepareForStorage = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref3) {
    var dbUtil, ctx;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            dbUtil = _ref3.dbUtil, ctx = _ref3.ctx;

          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function (_x2) {
    return _ref4.apply(this, arguments);
  };
}();

IObjectPersist.prototype.restoreFromStorage = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref5) {
    var dbUtil, ctx;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            dbUtil = _ref5.dbUtil, ctx = _ref5.ctx;

          case 1:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function (_x3) {
    return _ref6.apply(this, arguments);
  };
}();

IObjectPersist.prototype.cleanForApi = function (_ref7) {
  var dbUtil = _ref7.dbUtil,
      ctx = _ref7.ctx;
};

module.exports.IObjectPersist = IObjectPersist;
var IObjectIndex = new Interface({
  name: 'IObjectIndex'
}); // Returns a new plain js-object

IObjectIndex.prototype.getIndexableObject = function () {};

module.exports.IObjectIndex = IObjectIndex;